import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from "@angular/common";
import { BROWSER_EXTENSION_REQUEST_TIMEOUT, BROWSER_EXTENSION_STORE_URL } from './services/injection-tokens';

@NgModule({
    imports: [
        CommonModule,
    ],
    providers: [
        { provide: BROWSER_EXTENSION_REQUEST_TIMEOUT, useValue: 500 },
        {
            provide: BROWSER_EXTENSION_STORE_URL,
            useValue: '',
        }
    ],
})
export class SharedUtilBrowserExtensionModule {
    public static forRoot(requestTimeout: number, storeUrl: string): ModuleWithProviders<SharedUtilBrowserExtensionModule> {
        return {
            ngModule: SharedUtilBrowserExtensionModule,
            providers: [
                { provide: BROWSER_EXTENSION_REQUEST_TIMEOUT, useValue: requestTimeout },
                {
                    provide: BROWSER_EXTENSION_STORE_URL,
                    useValue: storeUrl,
                }
            ],
        };
    }
}
